import _createForOfIteratorHelperLoose from "@babel/runtime/helpers/esm/createForOfIteratorHelperLoose";
export var Listener = /*#__PURE__*/function () {
  function Listener() {
    this._listeners = [];
  }

  var _proto = Listener.prototype;

  _proto.subscribe = function subscribe(listener) {
    var _this = this;

    this._listeners.push(listener);

    return function () {
      var index = _this._listeners.indexOf(listener);

      if (index < 0) return;
      _this._listeners[index] = _this._listeners[_this._listeners.length - 1];
      _this._listeners.length--;
    };
  };

  _proto.notify = function notify(prevStore, newStore) {
    for (var _iterator = _createForOfIteratorHelperLoose(this._listeners), _step; !(_step = _iterator()).done;) {
      var listener = _step.value;
      listener(prevStore, newStore);
    }
  };

  return Listener;
}();